export default {
    namespaced: true,
    state: {
        jobs: [],
        randomJobs: [],
        job: {
            company: {}
        },
        pagedJobs: {
            results: [],
            count: 1
        },
        pagedRecommendJobs: {
            results: [],
            count: 1
        },
        searchJobsResult: {
            results: [],
            count: 1
        },
        latestJobs: []
    },
    getters: {
        jobs(state) {
            return state.jobs
        },
        randomJobs(state) {
            return state.randomJobs
        },
        job(state) {
            return state.job;
        },
        pagedJobs(state) {
            return state.pagedJobs;
        },
        pagedRecommendJobs(state) {
            return state.pagedRecommendJobs;
        },
        searchJobsResult(state) {
            return state.searchJobsResult
        },
        latestJobs (state) {
            return state.latestJobs;
        },
    },
    mutations: {
        setJobs(state, payload) {
            state.jobs = payload
        },
        setRandomJobs(state, payload) {
            state.randomJobs = payload
        },
        setJob(state, payload) {
            state.job = payload.job;
        },
        setPagedJobs(state, payload) {
            if (payload.jobs.previous === null) {
                state.pagedJobs = payload.jobs;
            } else {
                state.pagedJobs.results = state.pagedJobs.results.concat(payload.jobs.results)
                state.pagedJobs.count = payload.jobs.count
                state.pagedJobs.next = payload.jobs.next
                state.pagedJobs.previous = payload.jobs.previous
            }
        },
        setPagedRecommendJobs(state, payload) {
            if (payload.jobs.previous === null) {
                state.pagedRecommendJobs = payload.jobs;
            } else {
                state.pagedRecommendJobs.results = state.pagedRecommendJobs.results.concat(payload.jobs.results)
                state.pagedRecommendJobs.count = payload.jobs.count
                state.pagedRecommendJobs.next = payload.jobs.next
                state.pagedRecommendJobs.previous = payload.jobs.previous
            }
        },
        setLatestJobs(state, payload) {
            state.latestJobs = payload.jobs;
        },
        setSearchJobsResult(state, payload) {
            if (payload.result.previous === null) {
                state.searchJobsResult = payload.result
            } else {
                state.searchJobsResult.results = state.searchJobsResult.results.concat(payload.result.results)
                state.searchJobsResult.count = payload.result.count
                state.searchJobsResult.next = payload.result.next
                state.searchJobsResult.previous = payload.result.previous
            }
        },
        setLiked(state, payload) {
            const pagedJob = state.pagedJobs.results.find(job => job.id === payload.jobId)
            if (pagedJob) {
                pagedJob.isLiked = payload.liked
            }
            const recommendJob = state.pagedRecommendJobs.results.find(job => job.id === payload.jobId)
            if (recommendJob) {
                recommendJob.isLiked = payload.liked
            }
            const searchJob = state.searchJobsResult.results.find(job => job.id === payload.jobId)
            if (searchJob) {
                searchJob.isLiked = payload.liked
            }
        },
    },
    actions: {
        updateJobs({commit}, data) {
            commit("setJobs", data);
        },
        updateRandomJobs({commit}, data) {
            commit("setRandomJobs", data);
        },
        updateJob({commit}, {job}) {
            commit("setJob", {job: job});
        },
        updatePagedJobs({commit}, {jobs}) {
            commit("setPagedJobs", {jobs: jobs});
        },
        updatePagedRecommendJobs({commit}, {jobs}) {
            commit("setPagedRecommendJobs", {jobs: jobs});
        },
        updateLatestJobs({commit}, {jobs}) {
            commit("setLatestJobs", {jobs: jobs});
        },
        updateSearchJobsResult({commit}, {result}) {
            commit("setSearchJobsResult", {result})
        },
        updateLiked({commit}, {jobId, liked}) {
            commit("setLiked", {jobId, liked})
        }
    }
}
